import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { Menu } from './menu.model';
// import {verticalMenuItems, verticalMenuItemsTCD} from './menu';
import { PROFILE, THEME_PROFILE } from '../../helpers/globals';
import { menuItems } from './menu';

@Injectable()
export class MenuService {

    private profile = PROFILE;

    constructor(private location: Location,
        private router: Router) {
    }

    public async getVerticalMenuItems(): Promise<Array<Menu>> {
        return menuItems.filter(menu => !THEME_PROFILE.disabledFeatures.includes(menu.id));
    }

    // public getHorizontalMenuItems(): Array<Menu> {
    //     return horizontalMenuItems;
    // }

    public expandActiveSubMenu(menu: Array<Menu>) {
        const url = this.location.path();
        const routerLink = url; // url.substring(1, url.length);

        // Find active menu item by checking if the current URL starts with the menu's routerLink
        // This handles both exact matches and nested routes
        let activeMenuItem = menu.find(item => item.routerLink && url === item.routerLink);

        // If no exact match, try to find a parent route that matches
        if (!activeMenuItem) {
            activeMenuItem = menu.find(item => item.routerLink && url.startsWith(item.routerLink + '/'));
        }

        // If still no match, try without trailing slash
        if (!activeMenuItem) {
            activeMenuItem = menu.find(item => item.routerLink && item.routerLink.length > 1 && url.startsWith(item.routerLink));
        }

        if (activeMenuItem) {
            let menuItem = activeMenuItem;
            // Expand all parent menus
            while (menuItem.parentId !== '') {
                const parentMenuItem = menu.find(item => item.id === menuItem.parentId);
                if (parentMenuItem) {
                    menuItem = parentMenuItem;
                    this.toggleMenuItem(menuItem.id, true); // Force expand, don't toggle
                } else {
                    break; // Prevent infinite loop if parent not found
                }
            }
        }
    }


    public toggleMenuItem(menuId, forceExpand: boolean = false) {
        const menuItem = document.getElementById('menu-item-' + menuId);
        const subMenu = document.getElementById('sub-menu-' + menuId);
        if (subMenu && menuItem) {
            if (forceExpand) {
                // Only expand, don't collapse
                if (!subMenu.classList.contains('show')) {
                    subMenu.classList.add('show');
                    menuItem.classList.add('expanded');
                }
            } else {
                // Toggle behavior
                if (subMenu.classList.contains('show')) {
                    subMenu.classList.remove('show');
                    menuItem.classList.remove('expanded');
                } else {
                    subMenu.classList.add('show');
                    menuItem.classList.add('expanded');
                }
            }
        }
    }

    public closeOtherSubMenus(menu: Array<Menu>, menuId) {
        const currentMenuItem = menu.filter(item => item.id === menuId)[0];
        if (currentMenuItem.parentId === '' && !currentMenuItem.target) {
            menu.forEach(item => {
                if (item.id !== menuId) {
                    const subMenu = document.getElementById('sub-menu-' + item.id);
                    const menuItem = document.getElementById('menu-item-' + item.id);
                    if (subMenu) {
                        if (subMenu.classList.contains('show')) {
                            subMenu.classList.remove('show');
                            menuItem.classList.remove('expanded');
                        }
                    }
                }
            });
        }
    }
}
